export { default } from "./Stacked.js";
